// extracted by mini-css-extract-plugin
export default {"hideTooltip":"c9-z","fadeIn":"d9-z","delay":"e9-z","recommendedSizeTooltip":"f9-z"};